import { apiClient } from "api/ApiClient";

/**
 * 予約可能廃棄物一覧取得
 */
const getBookableWastes = async (): Promise<any> => {
    try {
        const response = await apiClient.get(`/booking_detail/bookable_wastes`);
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

export const BookableSolventApi = {
    getBookableWastes,
};
